module.exports = __webpack_public_path__ + "img/empty.881594df.svg";